import { Trans } from "@lingui/react/macro";
import { Heading } from "@medoma/components/Heading/Heading";
import { Text } from "@medoma/components/Text/Text";
import styles from "./patientNotes.module.scss";
import { GoBackLink } from "@/routes/profile/goBackLink";
import { useAcceptedPatientNote } from "@/api/patientNote";
import { humanFormat } from "@medoma/models/date-and-time";

export const PatientNotes = () => {
  const {
    data: acceptedPatientNote,
    isPending,
    isError,
  } = useAcceptedPatientNote();

  // Accepted patient note is always available at this point so no need to render loading or error state
  if (isPending || isError || !acceptedPatientNote) {
    return null;
  }

  const splitConvertedTextInParagraphs = acceptedPatientNote.convertedText
    .split("\n")
    .filter((paragraph) => paragraph.trim() !== "");

  const acceptedBy = acceptedPatientNote.acceptedBy ?? "";
  const acceptedDate = acceptedPatientNote.conversionTimeStamp
    ? humanFormat(acceptedPatientNote.conversionTimeStamp)
    : null;

  return (
    <>
      <GoBackLink />
      <div className={styles.container}>
        <Heading level="h1">
          <Trans>Detta har hänt</Trans>
        </Heading>
        <div className={styles.aiInfo}>
          <Text element="p" size="small" color="faded">
            <Trans>
              Texten baseras på läkarens anteckning och har gjorts mer läsbar
              med AI.
            </Trans>
          </Text>
        </div>
        {splitConvertedTextInParagraphs.map((paragraph, index) => (
          <Text element="p" key={index}>
            {paragraph}
          </Text>
        ))}
        <div className={styles.sentInfo}>
          <Text element="span" size="small" color="faded">
            <Trans>Godkänd av {acceptedBy}</Trans>
          </Text>
          {acceptedDate ? (
            <Text element="span" size="small" color="faded">
              {acceptedDate}
            </Text>
          ) : null}
        </div>
      </div>
    </>
  );
};
